var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.061 2.063c-.046-.943-.798-1.73-1.77-1.73H2.71c-.997 0-1.772.84-1.777 1.824v5.72c0 .99.774 1.835 1.776 1.835h8.58c1.008 0 1.777-.845 1.777-1.835V2.168c0-.035 0-.07-.006-.105zM2.711 1.44h8.58c.267 0 .524.18.617.46L8.11 4.347l-.047.035a1.654 1.654 0 01-2.12 0l-.052-.035L2.093 1.9c.093-.28.35-.46.617-.46zm9.25 6.437c0 .425-.321.728-.67.728H2.71c-.35 0-.67-.303-.67-.728V3.182L5.255 5.25l.023.017a2.759 2.759 0 003.443 0l.029-.017 3.21-2.062v4.689z",
    fill: "#0B0B0B"
  })));
}

export default SvgMail;